module.exports = __webpack_public_path__ + "dd621e8925229b71e8964568c3ae7008.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-ribbons-s.png
// module id = 2367
// module chunks = 0